import dayjs from "dayjs";
import { useNavigate } from "react-router";
import { useTransactionLogs } from "../../store/useTransactionLogs";

const formatAmount = (cents: number | undefined) =>
  new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format((cents ?? 0) / 100);

const formatUserName = (details?: {
  first_name?: string;
  last_name?: string;
  email?: string;
}) => {
  if (!details) return "-";
  const fullName = `${details.first_name ?? ""} ${details.last_name ?? ""}`
    .trim()
    .replace(/\s+/g, " ");
  if (fullName) return fullName;
  return details.email ?? "-";
};

export const TransactionLogsTable = () => {
  const { logs } = useTransactionLogs();
  const navigate = useNavigate();

  if (!logs?.length) return null;

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Sender
            </th>
            <th scope="col" className="px-1 sm:px-2 py-1 sm:py-4 text-center">
              →
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Receiver
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Before balance
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              After balance
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Difference
            </th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => {
            const diff = (log.afterBalance ?? 0) - (log.beforeBalance ?? 0);
            return (
              <tr
                key={log._id}
                className="bg-white hover:bg-gray-100 transition ease-linear border-b"
              >
                <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                  {dayjs(log.createdAt).format("YYYY-MM-DD HH:mm")}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {log.updatedByDetails?._id ? (
                    <button
                      type="button"
                      onClick={() =>
                        navigate(`/edit-user/${log.updatedByDetails?._id}`)
                      }
                      className="text-droppie-oranje hover:underline"
                    >
                      {formatUserName(log.updatedByDetails)}
                    </button>
                  ) : (
                    formatUserName(log.updatedByDetails)
                  )}
                </td>
                <td className="px-1 sm:px-2 py-1 sm:py-4 text-center text-gray-400">
                  →
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {log.userDetails?._id ? (
                    <button
                      type="button"
                      onClick={() =>
                        navigate(`/edit-user/${log.userDetails?._id}`)
                      }
                      className="text-droppie-oranje hover:underline"
                    >
                      {formatUserName(log.userDetails)}
                    </button>
                  ) : (
                    formatUserName(log.userDetails)
                  )}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {formatAmount(log.beforeBalance)}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {formatAmount(log.afterBalance)}
                </td>
                <td
                  className={`px-2 sm:px-6 py-1 sm:py-4 ${
                    diff > 0
                      ? "text-cc-green"
                      : diff < 0
                      ? "text-red-base"
                      : ""
                  }`}
                >
                  {formatAmount(diff)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

